import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Select, Row, Col, Table, message, Modal, Divider, Tooltip, Typography, Space } from 'antd';
import { currency } from '../formatNumber';
import { orderDomesticCancel, orderDomesticSubmit, orderDomesticOrderInfo } from '../api';
import { queryString } from '../../../util/qs';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import '../index.less';

const { Option } = Select;

const PlanStatus = {
  0: '未提报',
  1: '已提报',
  2: '已取消',
  3: '已失效',
  // 1: '计划收集待开始',
  // 2: '计划收集中',//(可提报)
  // 3: '采购待开始',
  // 4: '采购中',
  // 5: '已结束',
  // 6: '已取消',
};

class SearchItem extends Component {
  constructor(props) {
    super(props);
    const { item: { lists = [], order_update_time = '', is_new = 0, currency: _currency, currency_symbol, currency_en } } = props;
    const list = lists.map(item => ({ ...item, is_new, order_update_time }));
    const current = list[0] || {};
    const { city_name: currentCity } = current;

    this.state = {
      container_num: 1,
      isModalVisible: false,
      transportationCostModal: false,
      transportationCostDataSource: [],
      expectUnitPriceModal: false,
      expectUnitPriceDataSource: [],
      currentSubmits: [],
      list,
      current,
      currentCity,
      _currency,
      currency_symbol,
      currency_en
    };
    this.columns = [
      {
        title: "商品名称",
        dataIndex: "sku_name",
        align: "center",
        width: 300,
      },
      {
        title: `砍果成本(${this.state._currency || '泰铢'}/KG)`,
        dataIndex: "cut_fruit_price",
        align: "center",
        render: (text, record) => {
          const { exchange_rate, currency_symbol } = record;
          return `${currency_symbol || '฿'}${currency(text * (+exchange_rate))}`;
        }
      },
      {
        title: `单位清关完税价格（箱）`,
        dataIndex: "box_price",
        align: "center",
        render: (_, record) => {
          const { domestic_info, sale_price, number_of_boxes, cabinet_specification } = record;
          const number_of_boxes_price = sale_price * number_of_boxes;
          const { customs_clearance_cost = 0, port_cost = 0, domestic_financial_cost = 0 } = domestic_info || {};
          const domestic_info_every_price = (Number(customs_clearance_cost) + Number(port_cost) + Number(domestic_financial_cost)) / cabinet_specification * number_of_boxes;
          const currentPrice = Number(number_of_boxes_price) + Number(domestic_info_every_price) + Number(number_of_boxes_price * 0.09);
          return `¥${currency(currentPrice / number_of_boxes)}`;
        }
      },
      {
        title: "单位报价(含税.箱)",
        dataIndex: "fruit_cutting_cost",
        align: "center",
        width: 180,
        render: (_, record) => {
          const { domestic_info, transportation_cost, sale_price, number_of_boxes, cabinet_specification } = record;
          const number_of_boxes_price = sale_price * number_of_boxes;
          const { customs_clearance_cost = 0, port_cost = 0, domestic_financial_cost = 0 } = domestic_info || {};
          const domestic_info_every_price = (Number(transportation_cost) + Number(customs_clearance_cost) + Number(port_cost) + Number(domestic_financial_cost)) / cabinet_specification * number_of_boxes;
          const currentPrice = Number(number_of_boxes_price) + Number(domestic_info_every_price) + Number(number_of_boxes_price * 0.09);
          return <Space>
            <span>{`¥${currency(currentPrice / number_of_boxes)}`}</span>
            <Typography.Link type='link' onClick={() => this.openExpectUnitPriceDataSourceModal(record)}>详情</Typography.Link>
          </Space>;
        }
      },
      {
        title: "箱数",
        dataIndex: "cabinet_specification",
        align: "center",
        render: (text, record) => {
          return `${Number(record.number_of_boxes)} ${record.sale_unit}/柜`;
        }
      },
      {
        title: "供应商CIF报价",
        dataIndex: "cif_cn_up_cost",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text) => `¥${currency(text)}`
      },
      {
        title: "清关服务费",
        dataIndex: "customs_clearance_cost",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          const { domestic_info } = record;
          const { customs_clearance_cost = 0, remark = '' } = domestic_info || {};
          return <Space>
            <span>{`¥${currency(customs_clearance_cost * Number(this.state.container_num))}`}</span>
            <span>{remark ? <Tooltip title={remark}><QuestionCircleOutlined style={{ marginLeft: 10 }} /></Tooltip> : null}</span>
          </Space>;
        }
      },
      {
        title: "财务费",
        dataIndex: "domestic_financial_cost",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          const { domestic_info } = record;
          const { domestic_financial_cost = 0, } = domestic_info || {};
          return `¥${currency(domestic_financial_cost)}`;
        }
      },
      // {
      //   title: "港杂费",
      //   dataIndex: "port_cost",
      //   align: "center",
      //   render: (text, record) => {
      //     const { domestic_info } = record;
      //     return `¥${currency(domestic_info?.port_cost * Number(this.state.container_num))}`;
      //   }
      // },
      {
        title: "国内运费",
        dataIndex: "transportation_cost ",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          return <Space>
            <span>{`¥${currency(record.transportation_cost * Number(this.state.container_num))}`}</span>
            <Typography.Link type='link' onClick={this.openTransportationCostDataSourceModal}>详情</Typography.Link>
          </Space>;
        }
      },
      {
        title: "报价总额(含税)",
        dataIndex: "buyer_name",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          const { domestic_info, transportation_cost, tax_cost, cif_cn_up_cost } = record;
          const { customs_clearance_cost = 0, port_cost = 0, domestic_financial_cost = 0 } = domestic_info || {};
          const { container_num = 1 } = this.state;
          const currentPrice = Number(cif_cn_up_cost) + Number(customs_clearance_cost) + Number(port_cost) + Number(transportation_cost) + Number(domestic_financial_cost) + Number(tax_cost);
          // return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          return <div>
            <span>¥{currency(+currentPrice * Number(container_num))}</span>
            {/* <Typography.Link style={{ width: '30px' }} type='link' onClick={() => this.props.history.push(`/basic/quotation/detail?quotation_no=${quotation_no}&city_name=${city_name}&container_num=${container_num}`)}>明细</Typography.Link> */}
          </div>;
        }
      },
      {
        title: "报价状态",
        dataIndex: "submit_status",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          const { submit = [] } = record;
          const { submit_status } = submit?.[0] || {};
          const finallyStatus = submit.length ? submit_status : 0;
          return PlanStatus[+finallyStatus];
        }
      },
      {
        title: "已提报数量",
        dataIndex: "expected",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        render: (text, record) => {
          const { submit = [] } = record;
          const num = submit.reduce((pre, next) => pre + Number(next?.submit_number || 0), 0);
          return <>
            <span> {num || '-'}</span>
            {submit?.length ? <Typography.Link type='link' onClick={() => this.openModal(record)}>明细</Typography.Link> : null}
          </>;
        }
      },
      {
        title: "操作",
        dataIndex: "",
        align: "center",
        onCell: (record, index) => ({ rowSpan: index === 0 ? record.product_info.length : 0 }),
        fixed: 'right',
        render: (text, record) => {
          const { submit = [], plan_purchase_status, is_order } = record;
          const { submit_status = 0, transfer_order = 0 } = submit?.[0] || {};
          const isShow = +plan_purchase_status === 2 || (+plan_purchase_status === 4 && +submit_status === 1) || +transfer_order === 1 ? false : true;

          return <Space>
            {/* <span>submit_status:{submit_status}---{plan_purchase_status}</span> */}
            {+plan_purchase_status === 2 && !submit_status && <span><Typography.Link type='link' onClick={() => this.reporting(record, 1)}>提报</Typography.Link></span>}
            {+plan_purchase_status === 2 && +submit_status === 1 && <span><Typography.Link type='link' onClick={() => this.cancelReporting(record, 1)}>取消提报</Typography.Link></span>}
            {(+plan_purchase_status === 2 && +submit_status === 2) && <>
              {/* <span><Typography.Link type='link' onClick={() => this.changeReportingStatus(record)}>提报</Typography.Link></span> */}
              {/* <span><Typography.Link type='link' onClick={() => this.reporting(record, 2)}>编辑</Typography.Link></span> */}
              <span><Typography.Link type='link' onClick={() => this.reporting(record, 1)}>提报</Typography.Link></span>
            </>}
            {+plan_purchase_status === 4 && +submit_status === 1 && +is_order === 1 && <span><Typography.Link type='link' onClick={() => this.createOrder(record)}>创建采购单</Typography.Link></span>}
            {isShow ? '-' : null}
            {+transfer_order === 1 ? <Typography.Link type='link' onClick={() => this.props.history.push('/basic/user/order')}>查看采购单</Typography.Link> : null}
          </Space>;
        }
      }
    ];
    this.transportationCostColumns = [
      {
        title: '车型',
        dataIndex: "transportation_cost_type",
        align: "center",
      },
      {
        title: '承运范围',
        dataIndex: "transportation_cost_range",
        align: "center",
      },
      {
        title: '预估运费',
        dataIndex: "transportation_cost_price",
        align: "center",
        render: (text) => `¥${currency(text)}`
      },
      {
        title: '单位预估运费(箱)',
        dataIndex: "expect_unit_price",
        align: "center",
        render: (text) => `¥${currency(text)}`
      },
    ];
    this.expectUnitPriceColumns = [
      {
        title: '车型',
        dataIndex: "transportation_cost_type",
        align: "center",
      },
      {
        title: `单位清关完税价格(箱)`,
        dataIndex: "box_price",
        align: "center",
        render: (_, record) => {
          const { domestic_info, sale_price, number_of_boxes, cabinet_specification } = record;
          const number_of_boxes_price = sale_price * number_of_boxes;
          const { customs_clearance_cost = 0, port_cost = 0, domestic_financial_cost = 0 } = domestic_info || {};
          const domestic_info_every_price = (Number(customs_clearance_cost) + Number(port_cost) + Number(domestic_financial_cost)) / cabinet_specification * number_of_boxes;
          const currentPrice = Number(number_of_boxes_price) + Number(domestic_info_every_price) + Number(number_of_boxes_price * 0.09);
          return `¥${currency(currentPrice / number_of_boxes)}`;
        }
      },
      {
        title: '单位预估运费(箱)',
        dataIndex: "expect_unit_price",
        align: "center",
        render: (text) => `¥${currency(text)}`
      },
      {
        title: '单位报价(含税.箱)',
        dataIndex: "box_price_expect_unit_price",
        align: "center",
        render: (_, record) => {
          const { domestic_info, sale_price, number_of_boxes, expect_unit_price, cabinet_specification } = record;
          const number_of_boxes_price = sale_price * number_of_boxes;
          const { customs_clearance_cost = 0, port_cost = 0, domestic_financial_cost = 0 } = domestic_info || {};
          const domestic_info_every_price = (Number(customs_clearance_cost) + Number(port_cost) + Number(domestic_financial_cost)) / cabinet_specification * number_of_boxes;
          const currentPrice = Number(number_of_boxes_price) + Number(domestic_info_every_price) + Number(number_of_boxes_price * 0.09);
          return `¥${currency((currentPrice / number_of_boxes) + Number(expect_unit_price))}`;
        }
      },
    ];
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { item: { lists = [], order_update_time = '', is_new = 0 } } = nextProps;
    const list = lists.map(item => ({ ...item, is_new, order_update_time }));
    const current = list[0] || {};
    const { city_name: currentCity } = current;
    this.setState({ list, current, currentCity });
  }
  openModal = async (record) => {
    const { quotation_no, id: transportation_id } = record;
    const { data: { code, msg, data } } = await orderDomesticOrderInfo({ quotation_no, transportation_id });
    if (+code === 0) {
      // message.success(msg);
      // this.props.requestOrderDomesticSelect();
      this.setState({ currentSubmits: data, isModalVisible: true });
    } else {
      message.error(msg);
    }

    // orderDomesticInfo
    // const { product_info = [], submit = [] } = info;
    // const currentSubmits = submit.map(item => ({ ...item, product_info }));
    // this.setState({ currentSubmits, isModalVisible: true });
  }
  handleCancel = () => {
    this.setState({ isModalVisible: false, currentSubmits: [] });
  }

  changeReportingStatus = async (record) => {
    const { quotation_no, id: transportation_id } = record;
    const { data: { code, msg } } = await orderDomesticSubmit({ quotation_no, transportation_id });
    if (+code === 0) {
      message.success(msg);
      this.props.requestOrderDomesticSelect();
    } else {
      message.error(msg);
    }
  }

  cancelReporting = async (record) => {
    const { quotation_no, id: transportation_id } = record;
    const { data: { code, msg } } = await orderDomesticCancel({ quotation_no, transportation_id });
    if (+code === 0) {
      message.success(msg);
      this.props.requestOrderDomesticSelect();
    } else {
      message.error(msg);
    }
  }

  createOrder = (record) => {
    const { id, quotation_no } = record;
    this.props.history.push(`/basic/quotation/order?${queryString({ id, orderId: quotation_no })}`);
  }
  reporting = (record, type) => {
    this.props.history.push(`/basic/quotation/edit/${type}/${record?.id}/${record?.quotation_no}`);
  }

  onSelectChange = (e) => {
    const { list = [] } = this.state;
    const current = list.find(item => item.city_name === e);
    const { currentCity } = current;
    this.setState({ current, currentCity });
  }

  header = (info = {}) => {
    const { TransportOptions } = this.props;
    const { list = [] } = this.state;
    const { transportation_form, expected_arrival_port, arrival_port_code, estimated_departure_date_start, estimated_departure_date_end, plan_collect_start, plan_collect_end, quotation_no, name,
      estimated_arrival_data_start, estimated_arrival_data_end, create_time, date_of_fruit_cutting_start, date_of_fruit_cutting_end, purchase_start, purchase_end, currentCity,
      is_new, order_update_time } = info;
    return <div>
      <Row>
        <Col span={8}>报价单编号:{quotation_no}</Col>
        <Col span={8}>
          <Tooltip title={name}>
            <div className='self-ellipsis'>报价单名称:{name}</div>
          </Tooltip>
        </Col>
        <Col span={8}> <div className='search-item-tag-container'><span>更新时间:{order_update_time}</span>{is_new ? <span className='search-item-tag'>new</span> : null}</div></Col>
        {/* <Col span={8}>{is_new && <div className='search-item-tag-container'><span className='search-item-tag'>new</span><span>{order_update_time}更新</span> </div>}</Col> */}
        {/* <Col span={8}>计划收集周期:{`${plan_collect_start}~${plan_collect_end}`}</Col> */}
      </Row>
      <Row>
        <Col span={8}>报价创建日期:{create_time}</Col>
        <Col span={8}>预计离港周期(ETD):{`${estimated_departure_date_start}~${estimated_departure_date_end}`}</Col>
        <Col span={8}>计划收集周期:{`${plan_collect_start}~${plan_collect_end}`}</Col>
      </Row>
      <Row>
        <Col span={8}>砍果日期:{`${date_of_fruit_cutting_start}~${date_of_fruit_cutting_end}`}</Col>
        <Col span={8}>预计到港周期(ETA):{`${estimated_arrival_data_start}~${estimated_arrival_data_end}`}</Col>
        <Col span={8}>采购周期:{`${purchase_start}~${purchase_end}`}</Col>
      </Row>
      <Row>
        <Col span={8}>运输方式:{TransportOptions[+transportation_form - 1]?.key || '-'}</Col>
        <Col span={8}>出发地:{expected_arrival_port}{arrival_port_code ? `(${arrival_port_code})` : null}</Col>
        <Col span={8} >到达地:
          {list.length > 1 ? <Select
            className='search-item-select'
            defaultValue={currentCity}
            showSearch
            style={{ minWidth: 80, maxWidth: 180 }}
            bordered={false}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.includes(input)}
            onChange={(e) => this.onSelectChange(e)}
          // filterSort={(optionA, optionB) =>
          //   optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
          // }
          >
            {list.map((item, index) => <Option key={index} value={item.city_name}>{item.city_name}</Option>)}
          </Select> : currentCity}
        </Col>
      </Row>
    </div>;
  };


  openTransportationCostDataSourceModal = () => {
    const { large_transportation_cost = 0, middle_transportation_cost = 0, small_transportation_cost = 0, large_expect_unit_price = 0, middle_expect_unit_price = 0, small_expect_unit_price = 0 } = this.state.current;
    const transportationCostDataSource = [
      {
        transportation_cost_type: '15m大车',
        transportation_cost_range: '9.5-27吨  27-70m³',
        transportation_cost_price: large_transportation_cost,
        expect_unit_price: large_expect_unit_price,
        id: uuidv4()
      },
      {
        transportation_cost_type: '6.8m中车',
        transportation_cost_range: '4-9.5吨  15-27m³',
        transportation_cost_price: middle_transportation_cost,
        expect_unit_price: middle_expect_unit_price,
        id: uuidv4()
      },
      {
        transportation_cost_type: '4.2m小车',
        transportation_cost_range: '4吨内  15m³内',
        transportation_cost_price: small_transportation_cost,
        expect_unit_price: small_expect_unit_price,
        id: uuidv4()
      },
    ];
    this.setState({ transportationCostModal: true, transportationCostDataSource });
  }
  openExpectUnitPriceDataSourceModal = (record) => {
    const { large_transportation_cost = 0, middle_transportation_cost = 0, small_transportation_cost = 0, large_expect_unit_price = 0, middle_expect_unit_price = 0, small_expect_unit_price = 0 } = record;
    const expectUnitPriceDataSource = [
      {
        ...record,
        transportation_cost_type: '15m大车',
        transportation_cost_price: large_transportation_cost,
        expect_unit_price: large_expect_unit_price,
        id: uuidv4()
      },
      {
        ...record,
        transportation_cost_type: '6.8m中车',
        transportation_cost_price: middle_transportation_cost,
        expect_unit_price: middle_expect_unit_price,
        id: uuidv4()
      },
      {
        ...record,
        transportation_cost_type: '4.2m小车',
        transportation_cost_price: small_transportation_cost,
        expect_unit_price: small_expect_unit_price,
        id: uuidv4()
      },
    ];
    this.setState({ expectUnitPriceModal: true, expectUnitPriceDataSource });
  }

  render() {
    const { isModalVisible, currentSubmits, current = {}, currentCity, transportationCostModal, transportationCostDataSource = [], expectUnitPriceModal = false, expectUnitPriceDataSource = [], } = this.state;
    return (
      <>
        <div className='quotation-list-item quotation-list-item-base'>
          <Table
            title={() => this.header({ ...current, currentCity })}
            rowKey={(record) => record.id}
            columns={this.columns}
            dataSource={current.product_info.map(item => ({ ...current, ...item, pid: current.id }))}
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
        </div>
        {isModalVisible ? <Modal open={true} onCancel={this.handleCancel} footer={false} width={800}>
          <div className='quotation-modal-container'>
            {
              (currentSubmits || []).map((item, index) => {
                const { address, submit_number, product_info = [], order_no, expected_date, join_name, is_success = 0 } = item;
                return <div key={index} className='quotation-modal-item'>
                  {order_no ? <div>采购单号：<Typography.Link onClick={() => { this.props.history.push(`/basic/user/order?order_no=${order_no}`); }} >{`${order_no}`}</Typography.Link></div> : null}
                  <div>收货地址：{`${address}`}</div>
                  <div>期望到货日期：{`${expected_date}`}</div>
                  <div>
                    <span>提报数量：{submit_number} 柜</span>
                    {
                      +submit_number === 0.5 ? <>
                        {+is_success === 0 ? <span style={{ color: 'red' }}>(未拼柜成功)</span> : <span style={{ color: 'grey' }}>(拼柜成功  拼柜方：{join_name})</span>}
                      </> : null
                    }
                  </div>
                  <div>商品数量明细</div>
                  <table className='quotation-table'>
                    <tbody>
                      {(product_info || []).map((subItem, subIndex) => {
                        return <tr key={subIndex}>
                          <td className='quotation-table-td'>{subItem.sku_name}</td>
                          <td className='quotation-table-td'>{subItem.sale_number}{subItem.sale_unit}</td>
                        </tr>;
                      })}
                    </tbody>
                  </table>
                  {currentSubmits.length - 1 !== index ? < Divider /> : null}
                </div>;
              })
            }
          </div>
        </Modal> : null}

        {transportationCostModal ? <Modal
          open={true}
          width={800}
          onOk={() => this.setState({ transportationCostModal: false })}
          onCancel={() => this.setState({ transportationCostModal: false })}
          footer={null}
        >
          <Table bordered dataSource={transportationCostDataSource} pagination={false} rowKey={(record) => record.id} columns={this.transportationCostColumns} />
        </Modal> : null}
        {expectUnitPriceModal ? <Modal
          open={true}
          width={800}
          onOk={() => this.setState({ expectUnitPriceModal: false })}
          onCancel={() => this.setState({ expectUnitPriceModal: false })}
          footer={null}
        >
          <Table bordered dataSource={expectUnitPriceDataSource} pagination={false} rowKey={(record) => record.id} columns={this.expectUnitPriceColumns} />
        </Modal> : null}
      </>
    );
  }
}

export default withRouter(SearchItem);